import { useMediaQuery, useTheme } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  ListButton,
  SaveButton,
  SimpleForm,
  Toolbar,
  ToolbarProps,
  useTranslate,
  TextInput,
  NumberInput,
  SelectInput,
  Edit,
  EditProps,
  useEditContext,
  BooleanInput,
} from 'react-admin'
import { TicketDto } from '../../core/dto/ticket.dto'
import { TicketType } from '../../core/enum/TicketType'

const validateServiceBookingEdit = (values: TicketDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.id) {
    errors.id = 'ra.validation.required'
  }
  if (!values.bookingId) {
    errors.bookingId = 'ra.validation.required'
  }
  if (!values.ticketCode) {
    errors.ticketCode = 'ra.validation.required'
  }
  if (!values.ticketType) {
    errors.ticketType = 'ra.validation.required'
  }
  return errors
}

const CreateTitle = () => {
  const translate = useTranslate()
  return <span>{translate('resources.tickets.titles.edit')}</span>
}

const CreateToolbar = (props: ToolbarProps) => {
  const { basePath, ...rest } = props

  return (
    <Toolbar {...rest}>
      <SaveButton />
      <ListButton basePath={basePath} icon={<Cancel />} label="const.cancel" />
    </Toolbar>
  )
}

const TicketEditForm = ({ ...props }) => {
  const { record } = useEditContext()
  const translate = useTranslate()
  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <SimpleForm
      {...props}
      toolbar={<CreateToolbar />}
      validate={validateServiceBookingEdit}
      redirect={`/bookings/${record?.bookingId}/show/tickets`}
      basePath={`/bookings/${record?.bookingId}/show/tickets`}
    >
      <NumberInput source="bookingId" disabled />
      <NumberInput source="id" disabled />
      <TextInput source="ticketCode" />
      <SelectInput
        variant={!smallScreen ? 'standard' : undefined}
        source="ticketType"
        choices={Object.keys(TicketType).map((key: string) => ({
          id: key,
          name: translate(`resources.enums.ticketType.${key}`),
        }))}
      />
      <BooleanInput source="active" />
    </SimpleForm>
  )
}

export const TicketEdit = (props: EditProps) => (
  <Edit {...props} hasShow={false} title={<CreateTitle />}>
    <TicketEditForm {...props} />
  </Edit>
)
